import { testimonialsApi } from "../api/testimonials";
import { debounce } from "lodash";

const PER_PAGE = 10;

export default () => ({
  page: 1,
  posts: [],
  totalPages: 0,
  loading: true,
  async load() {
    this.loading = true;
    const response = await testimonialsApi.getTestimonials({
      perPage: PER_PAGE,
      page: this.page
    });
    this.totalPages = response.pages;
    this.posts.push(...response.data);
    this.loading = false;
  },
  onShowMore() {
    this.page += 1;
    this.debounceLoad();
  },
  init() {
    this.debounceLoad = debounce(() => this.load(), 500, {
      leading: true,
      trailing: true,
    });
    this.load();
  },
});
